module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column full-screen text-center align-items-stretch"
  }, [_c('div', {
    staticClass: "flex-all d-flex align-items-center justify-content-center"
  }, [_c('div', [_c('div', {
    staticClass: "dark mb-4"
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('h1', {
    staticClass: "darker"
  }, [_vm._v("Are you an agent or a supplier?")]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('router-link', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.agentTooltip),
      expression: "agentTooltip"
    }],
    staticClass: "btn blue super mr-4 outlined",
    attrs: {
      "to": {
        name: 'auth.signup.agent'
      }
    }
  }, [_vm._v("\n                    I'm a selling agent\n                ")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.supplierTooltip),
      expression: "supplierTooltip"
    }],
    staticClass: "btn action super outlined",
    attrs: {
      "to": {
        name: 'auth.signup.supplier'
      }
    }
  }, [_vm._v("\n                    I'm a service supplier\n                ")])], 1)])]), _vm._v(" "), _c('img', {
    staticClass: "banner mt-auto",
    attrs: {
      "src": "/static/images/auth/signup_bottom.jpg",
      "alt": ""
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0c288b59", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c288b59"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Signup.vue
// module id = 2575
// module chunks = 0